var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { load } from '@fingerprintjs/botd';
import { generateUUID } from './generateUUID';
export function isBot() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            if (typeof localStorage === 'undefined') {
                return yield isBotMachine();
            }
            const machineId = localStorage.getItem('BOT_MACHINE_ID') || generateUUID();
            const result = yield isBotMachine();
            if (result.isBot) {
                localStorage.setItem('BOT_MACHINE_ID', machineId);
                return Object.assign(Object.assign({}, result), { machineId });
            }
            return result;
        }
        catch (e) {
            return {
                isBot: false,
                reason: `Error: ${e === null || e === void 0 ? void 0 : e.message}`,
            };
        }
    });
}
function isBotMachine() {
    return __awaiter(this, void 0, void 0, function* () {
        const botd = yield load();
        const botdResult = botd.detect();
        if (botdResult && botdResult.bot === true) {
            return {
                isBot: true,
                reason: `@fingerprintjs/botd: ${botdResult.botKind}`,
            };
        }
        return {
            isBot: false,
        };
    });
}
//# sourceMappingURL=isBot.js.map